<template>
  <div class="table_select">
    <p class="text">
      {{ $t('message["1477"]') }}<span class="select_num">{{ count }}/{{ total }}</span>
    </p>
    <div class="opera_btns">
      <a-button
        :disabled="disabled"
        @click="cancel"
      >
        {{ $t('message["899"]') }}
      </a-button>
      <a-button
        :disabled="disabled"
        @click="mark"
      >
        {{ $t('message["51"]') }}
      </a-button>
    </div>
    <a
      href="javascript:;"
      class="del-sub-btn"
      :class="{'dis-del-sub-btn': count <= 0}"
      @click="delHandler"
    >
      {{ $t('message["982"]') }}
    </a>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {

    }
  },
  computed: {
    disabled () {
      return this.count === 0
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    mark () {
      this.$emit('mark')
    },
    delHandler () {
      this.$emit('delRecord')
    }
  }
}
</script>

<style scoped lang="scss">
.table_select {
  margin: 0 0 24px 0;
  border-top: 1px solid #EBEBEB;
  padding-top: 15px;
  .text {
    display: inline-block;
    color: $gray2;
    line-height: 24px;
    margin: 0 4px;
    .select_num {
      font-weight: 600;
      margin: 0 4px;
    }
  }
  .select_all_text:hover {
    cursor: pointer;
  }
  .opera_btns {
    display: inline-block;
  }
  .del-sub-btn {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  color: #fff;
  background: #f57676;
  border-radius: 4px;
  padding: 0 12px;
  margin-left: 48px;
}
.dis-del-sub-btn {
  opacity: 0.6;
  filter: alpha(opacity = 60);
  cursor: no-drop;
}
}
</style>
